// Toggle section anchors status
document.addEventListener('DOMContentLoaded', function () {
  let namespace = 'rnk-Hero_NavBar',
      navBar = document.querySelector(`.${namespace}`),
      navBarItems = navBar.querySelectorAll(`.${namespace}Item`),
      activeClass = `${namespace}Item-active`

  const resetActive = () => {
    navBarItems.forEach(element => {
      element.classList.remove(activeClass)
    })
  }

  navBarItems.forEach(navBarItem => {
    navBarItem.addEventListener('click', () => {
      resetActive()
      navBarItem.classList.add(activeClass)
    })
  })
})
